import Axios from 'axios';

const api = Axios.create({
    baseURL: process.env.VUE_APP_TEACHER_API_URL,
    headers: {
        'X-VERSION': '1',
        'X-CLIENT-OS': 'WEB',
        'X-CLIENT-TYPE': 'IAMTEACHER',
    },
});

export default {
    patchDrawResultRead({enrolmentNo, receiverNo}) {
        return api.patch(`/external/enrolments/${enrolmentNo}/receivers/${receiverNo}/read`);
    },
}
